import { render, staticRenderFns } from "./organizations-list-header.vue?vue&type=template&id=0c1838de&scoped=true&"
import script from "./organizations-list-header.vue?vue&type=script&lang=js&"
export * from "./organizations-list-header.vue?vue&type=script&lang=js&"
import style0 from "./organizations-list-header.vue?vue&type=style&index=0&id=0c1838de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1838de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c1838de')) {
      api.createRecord('0c1838de', component.options)
    } else {
      api.reload('0c1838de', component.options)
    }
    module.hot.accept("./organizations-list-header.vue?vue&type=template&id=0c1838de&scoped=true&", function () {
      api.rerender('0c1838de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/partials/organizations-list-header.vue"
export default component.exports